export const identicalValidator = (comparer) => {
    return (control) => {
        return control.value == comparer.value ? null : { identical: true }
    }
}